import { CG_URL } from './home/HomeModule';

/* Adatforrások egy halvány sorban a láblécben, a kockázati figyelmeztetés mellett.
   CoinGecko API Terms 4.4: „Powered by CoinGecko”, olvasható betűvel, legalább
   10-es méretben. Az adat közelében a modulok apró jelölést is adnak
   (CoinGeckoMark, Alternative.me a Fear & Greed alatt). */
const L = (href, text) => <a href={href} target="_blank" rel="noopener noreferrer">{text}</a>;

export default function DataCredits() {
  return (
    <span className="data-credits">
      Adatok: {L(CG_URL, 'Powered by CoinGecko')}
      {' · '}{L('https://alternative.me/crypto/fear-and-greed-index/', 'Alternative.me')}
      {' · '}{L('https://www.bybit.com/', 'Bybit')}
      {' · '}{L('https://www.binance.com/', 'Binance')}
      {' · '}{L('https://www.deribit.com/', 'Deribit')}
      {' · '}{L('https://defillama.com/', 'DefiLlama')}
      {' · '}Grafikon: {L('https://www.tradingview.com/', 'TradingView')}
    </span>
  );
}
